"use client";

import { Analytics as DubAnalytics } from "@dub/analytics/react";

const COOKIE_OPTIONS = {
  expiresInDays: 90,
  path: "/",
  sameSite: "lax" as const,
  secure: true,
};

export function MlxDubAnalytics() {
  return (
    <DubAnalytics
      attributionModel="last-click"
      cookieOptions={COOKIE_OPTIONS}
    />
  );
}
